import Vue from 'vue';
import router from './router';
import store from './store';
import App from './App';

import trimDirective from '@/directive/trimDirective';

Vue.directive('trim', trimDirective);
// elementui
import Elementui from './plugins/elementui';
Elementui(Vue);

// 全局方法注册
import register from '@/plugins/register';
register(Vue);
// 全局css
import './plugins/css';
// 国际化
import i18n from './locales/index.js';
export default new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: (h) => h(App)
});
